import { forEach } from 'lodash-es'

import { Color, Gradient } from '../../common/models'

export interface ColorCircleProps {
  color1?: Color
  color2?: Color
  from?: 'right' | 'left' | 'top' | 'bottom'
  to?: 'right' | 'left' | 'top' | 'bottom'
  text?: string
  gradient?: Gradient
  withBorder?: boolean
}

const normalize = (val: number, max: number, min: number) => {
  return (val - min) / (max - min)
}

export const hexToAlpha = (alphaHexString: string) => {
  return Math.round(normalize(parseInt(alphaHexString, 16), 255, 0) * 100)
}

const convertHexToRGBA = (hexCode: string) => {
  const hex = hexCode.replace('#', '')

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  let a = hexToAlpha(hex.substring(6, 8))

  if (a > 1 && a <= 100) {
    a = a / 100
  }

  return `rgba(${r},${g},${b},${a})`
}

export const ColorCircle = (props: ColorCircleProps) => {
  const { gradient, color1, color2, text = '', withBorder } = props
  if (gradient) {
    let linearGradient = ''
    forEach(gradient.colors, (colors) => {
      linearGradient += `${colors.color.value}, `
    })
    return (
      <div className="flex gap-2 items-center">
        <div
          className="flex w-[24px] h-[24px] rounded-[25px]"
          style={{
            background: `linear-gradient(90deg, ${linearGradient.slice(
              0,
              linearGradient.length - 2,
            )})`,
            ...(withBorder
              ? {
                  borderWidth: 1,
                  borderColor: 'black',
                  borderStyle: 'solid',
                }
              : {}),
          }}
        />
        <span className="text-body-medium">{text}</span>
      </div>
    )
  } else if (color1 && color2) {
    return (
      <div className="flex gap-2 items-center">
        <div
          className="w-[24px] h-[24px] rounded-[25px] border border-monochrome-120"
          style={{
            background: `linear-gradient(${color1?.value}, ${color2?.value})`,
          }}
        />
        <span className="text-body-medium">{text}</span>
      </div>
    )
  }
  return null
}
